module.exports = __webpack_public_path__ + "static/media/Add_image.2459644d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Add_image.png
// module id = 206
// module chunks = 0